exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-2ef3d763]{width:1em;height:1em}.icon__char[data-v-2ef3d763]{fill:currentColor}", ""]);

// exports
